// Vendors pack - contains shared dependencies
// This file is required by the application layout
console.log('Vendors pack loaded');
